<template>
  <v-container fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs fluid class="mb-0 pb-0" style="padding: 0px;">
        <v-layout row style="padding: 0px;">
          <v-flex md6>
            <v-text-field
              ref="form"
              class="mr-1"
              prepend-icon="search"
              label="Search"
              v-model="searchItem"
              clearable
              hide-details
            ></v-text-field>

            <!-- <search-field @search="search"></search-field> -->
          </v-flex>
          <v-spacer></v-spacer>
          <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
          ></v-select>
          <v-spacer width="1px"></v-spacer>
          <v-btn fab dark small color="amber darken-2" @click="getData">
            <v-icon dark>play_arrow</v-icon>
          </v-btn>
          <refresh-button @refresh="refreshTable()"></refresh-button>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadTemplate()"
            >
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px;" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="dateFromMenu"
                :close-on-content-click="false"
                v-model="dateFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFrom"
                  label="Date From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="dateFromMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="timeFromMenu"
                :close-on-content-click="false"
                v-model="timeFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeFrom"
                  @click="clockMode = 'timeFrom'"
                  label="Time From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-time-picker v-model="timeFrom" format="24hr">
                  <v-btn flat color="amber" @click="cancelTimePicker"
                    >Cancel</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat color="amber" @click="timeFromMenu = false"
                    >DONE</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-flex>

            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="dateToMenu"
                :close-on-content-click="false"
                v-model="dateToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateTo"
                  label="Date To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateTo"
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="dateFrom"
                  @input="dateToMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="timeToMenu"
                :close-on-content-click="false"
                v-model="timeToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeTo"
                  @click="clockMode = 'timeTo'"
                  label="Time To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>
                <v-time-picker v-model="timeTo" format="24hr">
                  <v-btn flat color="amber" @click="cancelTimePicker"
                    >Cancel</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat color="amber" @click="timeToMenu = false"
                    >DONE</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container fluid class="pa-2">
          <v-layout row>
            <v-flex sm4 md4 class="pl-0">
              <v-btn @click="openFilterExpansion">
                <v-icon class="mr-3">
                  {{ openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
                </v-icon>
                <span>Filter {{ title }}</span>
              </v-btn>
            </v-flex>
            <v-flex sm8 md8></v-flex>
          </v-layout>
        </v-container>

        <v-divider></v-divider>

        <filter-panel :openFilter="openFilter">
          <v-flex md4>
            <v-select
              v-model="filterShiftReport"
              :items="filterShiftReports"
              label="STATUS"
              solo
              clearable
            ></v-select>
          </v-flex>
        </filter-panel>
      </v-container>
      <shift-reports
        :items="items"
        :tableStyle="theTableStyle"
        :title="title"
        :headers="theActualHeaders"
        style="padding: 0px;"
        @sync="syncToWireless"
        @transactionALign="transactionALign"
      ></shift-reports>

      <message-dialog
        :dialog="messageDialog"
        :title="messageTitle"
        :message="messageText"
        @save="action === 'align' ? saveAlignTransaction() : ''"
        @close="closeMessageDialog"
        :loading="messageLoading"
      ></message-dialog>

      <message-dialog
        :dialog="messageDialogTransactionAlign"
        :title="messageTitleTransactionAlign"
        :message="messageTextTransactionAlign"
        @save="
          actionTransactionAlign === 'transactionAlign'
            ? saveTransactionAlignTransaction()
            : ''
        "
        @close="closeTransactionALignMessageDialog"
        :loading="messageLoadingTransactionALign"
      ></message-dialog>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
import ShiftReports from "@/components/tripko/ExceptionReports/ShiftReports";
// var jsonexport = require("jsonexport");
var now = new Date();

export default {
  components: {
    ShiftReports,
  },
  data() {
    return {
      openFilter: false,
      filterShiftReports: [],
      filterShiftReport: null,
      timeOut: null,
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      theTableStyle: false,
      tableItems: [
        {
          text: "Default Table",
          value: false,
        },
        {
          text: "Grid Style Table",
          value: true,
        },
      ],
      title: "Shift Report",
      excel_header: [
        {
          text: "Merchant Code",
          align: "left",
          value: "merchant",
          sortable: false,
        },
        {
          text: "Control No.",
          align: "left",
          value: "control_no",
          sortable: false,
        },
        {
          text: "Device Code",
          align: "left",
          value: "device_serial",
          sortable: false,
        },
        {
          text: "Branch",
          align: "left",
          value: "branch",
          sortable: false,
        },
        {
          text: "Opening Date",
          align: "center",
          value: "opening_date",
          sortable: false,
        },
        {
          text: "Opening Time",
          align: "center",
          value: "opening_time",
          sortable: false,
        },
        {
          text: "End Date",
          align: "center",
          value: "end_date",
          sortable: false,
        },
        {
          text: "End Time",
          align: "center",
          value: "end_time",
          sortable: false,
        },
        {
          text: "Opening Trx#",
          align: "left",
          value: "opening_trx#",
          sortable: false,
        },
        {
          text: "Closing Trx#",
          align: "left",
          value: "closing_trx#",
          sortable: false,
        },
        {
          text: "Reload Count",
          align: "right",
          value: "reload_count",
          sortable: false,
        },
        {
          text: "Reload Gross",
          align: "right",
          value: "reload_gross",
          sortable: false,
        },
        {
          text: "Sold Count",
          align: "right",
          value: "sold_count",
          sortable: false,
        },
        {
          text: "Sold Gross",
          align: "right",
          value: "sold_gross",
          sortable: false,
        },
        {
          text: "Sold Credit Count",
          align: "left",
          value: "credit_sold_count",
          sortable: true,
        },
        {
          text: "Sold Credit Gross",
          align: "left",
          value: "credit_sold_gross",
          sortable: true,
        },
        {
          text: "Balance Count",
          align: "right",
          value: "balance_count",
          sortable: false,
        },
        {
          text: "Credit Count",
          align: "right",
          value: "credit_count",
          sortable: false,
        },
        {
          text: "Total Gross",
          align: "right",
          value: "total_gross",
          sortable: false,
        },
        {
          text: "Total Count",
          align: "right",
          value: "total_count",
          sortable: false,
        },
        {
          text: "Cashier Name",
          align: "left",
          value: "cashier_name",
          sortable: false,
        },
        {
          text: "Opening Location",
          align: "left",
          value: "lat",
          sortable: false,
        },
        {
          text: "Closing Location",
          align: "left",
          value: "long",
          sortable: false,
        },
      ],
      headers: [
        // { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Merchant Code",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Device Serial",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Branch",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Opening Shift Date",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Closing Shift Date",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Date Validation",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Reload Count Wireless",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Reload Gross Wireless",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Sold Count Wireless",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Sold Gross Wireless",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Sold Credit Count Wireless",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Sold Credit Gross Wireless",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Credit Redeem Count Wireless",
          align: "left",
          value: "credit_red_count_wire",
          sortable: true,
        },
        {
          text: "Transfer Count Wireless",
          align: "left",
          value: "transfer_count_wire",
          sortable: true,
        },
        {
          text: "Transfer Fee Gross Wireless",
          align: "left",
          value: "transfer_fee_gross_wire",
          sortable: true,
        },
        {
          text: "Transfer Reload Count Wireless",
          align: "left",
          value: "transfer_reload_count_wire",
          sortable: true,
        },
        {
          text: "Transfer Reload Total Amount Wireless",
          align: "left",
          value: "transfer_reload_total_amount_wire",
        },
        {
          text: "Credit Gross Wireless",
          align: "left",
          value: "credit_gross_wire",
          sortable: true,
        },
        {
          text: "Credit Count Wireless",
          align: "left",
          value: "credit_count_wire",
          sortable: true,
        },
        {
          text: "Amount Wireless",
          align: "right",
          value: "amount",
          sortable: true,
        },
        {
          text: "Total Count Wireless",
          align: "right",
          value: "total_count_wireless",
          sortable: true,
        },
        {
          text: "Reload Count Sync",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Reload Gross Sync",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Sold Count Sync",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Sold Gross Sync",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Sold Credit Count Sync",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Sold Credit Gross Sync",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Credit Redeem Count Sync",
          align: "left",
          value: "credit_red_count_sync",
          sortable: true,
        },
        {
          text: "Transfer Count Sync",
          align: "left",
          value: "transfer_count_sync",
          sortable: true,
        },
        {
          text: "Transfer Fee Gross Sync",
          align: "left",
          value: "transfer_fee_gross_sync",
          sortable: true,
        },
        {
          text: "Transfer Reload Count Sync",
          align: "left",
          value: "transfer_reload_count_sync",
          sortable: true,
        },
        {
          text: "Transfer Reload Total Amount Sync",
          align: "left",
          value: "transfer_reload_total_amount_sync",
        },
        {
          text: "Credit Gross Sync",
          align: "left",
          value: "credit_gross_sync",
          sortable: true,
        },
        {
          text: "Credit Count Sync",
          align: "left",
          value: "credit_count_sync",
          sortable: true,
        },
        {
          text: "Amount Sync",
          align: "right",
          value: "amount",
          sortable: true,
        },
        {
          text: "Total Count Sync",
          align: "right",
          value: "total_count_sync",
          sortable: true,
        },
        {
          text: "Discrepancy",
          align: "right",
          value: "amount",
          sortable: true,
        },
        {
          text: "Cashier Name",
          align: "center",
          value: "cashier_name",
          sortable: false,
        },
      ],
      theActualHeaders: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        { text: "Action", align: "center", sortable: false },
        {
          text: "Merchant Code",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Device Serial",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Branch",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Opening Shift Date",
          align: "center",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Closing Shift Date",
          align: "center",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Date Validation",
          align: "center",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Reload Count (W)",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Reload Gross (W)",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Sold Count (W)",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Sold Gross (W)",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Sold Credit Count (W)",
          align: "left",
          value: "credit_sold_count_w",
          sortable: true,
        },
        {
          text: "Sold Credit Gross (W)",
          align: "left",
          value: "credit_sold_gross_w",
          sortable: true,
        },
        {
          text: "Credit Redeem Count (W)",
          align: "left",
          value: "credit_redeem_count_w",
          sortable: true,
        },
        {
          text: "Credit Count (W)",
          align: "left",
          value: "credit_count_wireless",
          sortable: true,
        },
        {
          text: "Credit Gross (W)",
          align: "left",
          value: "credit_gross_wireless",
          sortable: true,
        },
        {
          text: "Transfer Count (W)",
          align: "left",
          value: "transfer_count_w",
          sortable: true,
        },
        {
          text: "Transfer Fee Card (W)",
          align: "left",
          value: "transfer_fee_card_w",
          sortable: true,
        },
        {
          text: "Transfer Fee Cash (W)",
          align: "left",
          value: "transfer_fee_cash_w",
          sortable: true,
        },
        {
          text: "Transfer Fee Gross (W)",
          align: "left",
          value: "transfer_fee_gross_w",
          sortable: true,
        },
        {
          text: "Amount (W)",
          align: "left",
          value: "amount",
          sortable: true,
        },
        {
          text: "Total Count (W)",
          align: "right",
          value: "total_count",
          sortable: true,
        },
        {
          text: "Reload Count (S)",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Reload Gross (S)",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Sold Count (S)",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "Sold Gross (S)",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Sold Credit Count (S)",
          align: "left",
          value: "credit_sold_count_s",
          sortable: true,
        },
        {
          text: "Sold Credit Gross (S)",
          align: "left",
          value: "credit_sold_gross_s",
          sortable: true,
        },
        {
          text: "Credit Redeem Count (S)",
          align: "left",
          value: "credit_redeem_count_s",
          sortable: true,
        },
        {
          text: "Credit Count (S)",
          align: "left",
          value: "credit_count_sync",
          sortable: true,
        },
        {
          text: "Credit Gross (S)",
          align: "left",
          value: "credit_gross_sync",
          sortable: true,
        },
        {
          text: "Transfer Count (S)",
          align: "left",
          value: "transfer_count_s",
          sortable: true,
        },
        {
          text: "Transfer Fee Card (S)",
          align: "left",
          value: "transfer_fee_card_s",
          sortable: true,
        },
        {
          text: "Transfer Fee Cash (S)",
          align: "left",
          value: "transfer_fee_Cash_s",
          sortable: true,
        },
        {
          text: "Transfer Fee Gross (S)",
          align: "left",
          value: "transfer_fee_gross_s",
          sortable: true,
        },
        {
          text: "Transaction Lost Count",
          align: "right",
          value: "lost_transaction_count",
          sortable: true,
        },
        {
            text: "Transaction Lost Total",
            align: "right",
            value: "lost_transaction_total",
            sortable: true,
        },

        {
          text: "Amount (S)",
          align: "left",
          value: "amount",
          sortable: true,
        },
        {
          text: "Total Count (S)",
          align: "right",
          value: "total_count",
          sortable: true,
        },
        {
          text: "Validation",
          align: "right",
          value: "amount",
          sortable: true,
        },
        {
          text: "Cashier Name",
          align: "left",
          value: "cashier_name",
          sortable: false,
        },
      ],
      vehicleHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
      ],
      items: [],
      vehicleItems: [],
      queryParams: {
        aligned: null,
        date_from: null,
        date_to: null,
        search: "",
        type: null,
      },
      dialogType: "",
      dialogColor: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
      ],
      selected: [],
      addDialog: false,

      subscribeDialog: false,
      assignItems: [],
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      subcompanies: [],
      vehicleTypes: [],
      filterTypes: [
        {
          text: "BOOK",
          value: 1,
        },
        {
          text: "REBOOK",
          value: 2,
        },
        {
          text: "CANCEL",
          value: 3,
        },
        {
          text: "REFUND",
          value: 4,
        },
        {
          text: "REPRINT",
          value: 5,
        },
        {
          text: "BAGGAGE",
          value: 6,
        },
      ],
      filterType: null,
      menu: false,
      menu1: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      downLoading: false,
      messageDialog: false,
      messageTitle: "",
      messageText: "",
      messageLoading: false,
      action: "",
      body: {},
      messageDialogTransactionAlign: false,
      messageTitleTransactionAlign: "",
      messageTextTransactionAlign: "",
      messageLoadingTransactionALign: false,
      actionTransactionAlign: "",
      bodyTransactionAlign: {},
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
    totalFinalFare() {
      let total = 0;

      this.items.map((value) => {
        total += value.final_fare;
      });

      return total;
    },
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
  },
  watch: {
    filterShiftReport: async function() {
      if (
        this.filterShiftReport !== null &&
        this.filterShiftReport !== undefined &&
        this.filterShiftReport !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.aligned = this.filterShiftReport;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.aligned = null;
      }
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];

      this.queryParams.date_from = this.dateFrom + " " + this.timeFrom + ":00";
      this.queryParams.date_to = this.dateTo + " " + this.timeTo + ":59";

      this.queryParams.type = this.filterType;
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (
          await Services.getShiftWirelessAndSync(this.queryParams)
        ).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterShiftReport();
    },
    async setFilterShiftReport() {
      this.filterShiftReports = [
        { text: "ALIGNED", value: true },
        { text: "UNALIGNED", value: false },
      ];
    },
    async getProjects() {
      // Start Loading
      this.assignItems = [];
      const response = this.$store.state.subcompany;

      this.assignItems = response.projects;
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getVehicle(id);
        data = await response.data;
        data.name = data.name ? data.name.toUpperCase() : "";
        data.city = data.city ? data.city.toUpperCase() : "";
        data.province = data.province ? data.province.toUpperCase() : "";
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return data;
    },
    // async setSubCompanies() {
    //   this.subcompanies = [];
    //   const items = (await Services.getSubCompanies({
    //     company_id: this.$store.state.company.id
    //   })).data;
    //   for (var i = 0, el = items.data; i < el.length; i++) {
    //     let data = {
    //       text: el[i].name.toUpperCase(),
    //       value: el[i].id
    //     };
    //     this.subcompanies.push(data);
    //   }
    // },
    // async setVehicleTypes() {
    //   this.vehicleTypes = [];
    //   const items = (await Services.getVehicleTypes({
    //     company_id: this.$store.state.company.id
    //   })).data;
    //   for (var i = 0, el = items.data; i < el.length; i++) {
    //     let data = {
    //       text: el[i].name.toUpperCase(),
    //       value: el[i].id
    //     };
    //     this.vehicleTypes.push(data);
    //   }
    // },
    async setVehicles() {
      this.vehicleItems = [];
      this.vehicleItems = (
        await Services.getVehiclesUnassignedProject({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          project_id: this.$store.state.project.id,
        })
      ).data;
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.addDialog = true;

      this.setVehicles();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;
      this.dialogColor = "green";
      this.dialogType = "edit";
      this.dialogStatus = true;

      //   await this.setSubCompanies();
      //   await this.setVehicleTypes();

      //   this.viewData = await this.setData(data.id);
      this.viewData = await data;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      if (this.$refs.form.validate()) {
        this.openConfirmDialog = true;
      }
    },
    async saveConfirmedAddDialog() {
      this.confirmLoading = true;

      const vehicles = this.selected.map((vehicle) => {
        return {
          id: vehicle.id,
        };
      });

      const body = {
        vehicles: vehicles,
        project_id: this.$store.state.project.id,
      };
      try {
        const response = await Services.assignVehicletoProject(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeAddDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Vehicle(s) has been added",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          amount_received: data.amount_received,
          status: 2,
        };
      try {
        const response = await Services.updateRemittance(data.id, body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Vehicle has been updated!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteVehicle(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Vehicle has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      this.viewData = {};

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    closeAddDialog() {
      this.selected = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.addDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.vehicleItems.slice();
    },
    async openSubscribeDialog(data) {
      this.dialogLoading = true;
      this.dialogType = "assign";
      this.subscribeDialog = true;
      this.viewData = data;

      this.viewData = await this.setData(data.id);
      this.assignedItems = await this.viewData.projects;
      await this.getProjects();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async closeSubscribeDialog() {
      this.selected = [];
      this.viewData = {};
      this.closeConfirmDialog();
      this.dialogType = "";
      this.subscribeDialog = false;
    },
    saveSubscribeDialog() {
      this.openConfirmDialog = true;
    },
    notSubscribe(data) {
      for (var e = 0; e < this.assignedItems.length; e++) {
        if (this.assignedItems[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    showSubcribe(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    subscribeToProject(data) {
      this.selected.push(data);
    },
    unsubscribeToProject(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          this.selected.splice(e, 1);
        }
      }
    },
    async saveConfirmedSubscribeDialog() {
      this.confirmLoading = true;

      const projects = this.selected.map((project) => {
        return {
          id: project.id,
        };
      });
      const body = {
        projects: projects,
        vehicle_id: this.viewData.id,
      };
      try {
        const response = await Services.assignVehicletoProject(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeSubscribeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Project/s has been assigned to Vehicle!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    refreshTable() {
      this.$refs.form.reset();
      this.dateFrom = this.$dateFormat(now, "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(now, "YYYY-MM-DD");
      this.getData();
    },
    async downloadTemplate() {
      let dataToDownload = [];
      let header = [];

      for (let i = 2; i < this.theActualHeaders.length; i++) {
        header.push(this.theActualHeaders[i].text.toUpperCase());
      }

      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];

        theItem.push(
          this.items[e].merchant === null ? "--" : this.items[e].merchant
        ),
          theItem.push(
            this.items[e].device_serial === null
              ? "--"
              : this.items[e].device_serial
          ),
          theItem.push(
            this.items[e].terminal === null ? "--" : this.items[e].terminal
          ),
          theItem.push(
            this.items[e].opening_shift_datetime === null
              ? "--"
              : this.$dateFormat(
                  this.items[e].opening_shift_datetime,
                  "YYYY-MM-DD"
                )
          ),
          theItem.push(
            this.items[e].closing_shift_datetime === null
              ? "--"
              : this.$dateFormat(
                  this.items[e].closing_shift_datetime,
                  "YYYY-MM-DD"
                )
          ),
          theItem.push(
            this.items[e].date_validation === null
              ? "--"
              : this.items[e].date_validation
          ),
          theItem.push(
            this.items[e].reload_count_wireless === null
              ? "--"
              : this.items[e].reload_count_wireless
          ),
          theItem.push(
            this.items[e].reload_gross_wireless === null
              ? "--"
              : this.items[e].reload_gross_wireless
          ),
          theItem.push(
            this.items[e].sold_count_wireless === null
              ? "--"
              : this.items[e].sold_count_wireless
          ),
          theItem.push(
            this.items[e].sold_gross_wireless === null
              ? "--"
              : this.items[e].sold_gross_wireless
          ),
          theItem.push(
            this.items[e].credit_sold_count_wireless === null
              ? "--"
              : this.items[e].credit_sold_count_wireless
          ),
          theItem.push(
            this.items[e].credit_sold_gross_wireless === null
              ? "--"
              : this.items[e].credit_sold_gross_wireless
          ),
          theItem.push(
            this.items[e].credit_redeem_count_wireless === null
              ? "--"
              : this.items[e].credit_redeem_count_wireless
          ),
          theItem.push(
            this.items[e].credit_count_wireless === null
              ? "--"
              : this.items[e].credit_count_wireless
          ),
          theItem.push(
            this.items[e].credit_gross_wireless === null
              ? "--"
              : this.items[e].credit_gross_wireless
          ),
          theItem.push(
            this.items[e].transfer_count_wireless === null
              ? "--"
              : this.items[e].transfer_count_wireless
          ),
          theItem.push(
            this.items[e].transfer_fee_card_wireless === null
              ? "--"
              : this.items[e].transfer_fee_card_wireless
          ),
          theItem.push(
            this.items[e].transfer_fee_cash_wireless === null
              ? "--"
              : this.items[e].transfer_fee_cash_wireless
          ),
          theItem.push(
            this.items[e].transfer_fee_gross_wireless === null
              ? "--"
              : this.items[e].transfer_fee_gross_wireless
          ),
          theItem.push(
            this.items[e].gross_revenue_wireless === null
              ? "--"
              : this.items[e].gross_revenue_wireless
          ),
          theItem.push(
            this.items[e].reload_count_wireless +
              this.items[e].sold_count_wireless +
              this.items[e].credit_sold_count_wireless +
              this.items[e].credit_redeem_count_wireless +
              this.items[e].transfer_count_wireless +
              this.items[e].credit_count_wireless
          ),
          theItem.push(
            this.items[e].reload_count_sync === null
              ? "--"
              : this.items[e].reload_count_sync
          ),
          theItem.push(
            this.items[e].reload_gross_sync === null
              ? "--"
              : this.items[e].reload_gross_sync
          ),
          theItem.push(
            this.items[e].sold_count_sync === null
              ? "--"
              : this.items[e].sold_count_sync
          ),
          theItem.push(
            this.items[e].sold_gross_sync === null
              ? "--"
              : this.items[e].sold_gross_sync
          ),
          theItem.push(
            this.items[e].credit_sold_count_sync === null
              ? "--"
              : this.items[e].credit_sold_count_sync
          ),
          theItem.push(
            this.items[e].credit_sold_gross_sync === null
              ? "--"
              : this.items[e].credit_sold_gross_sync
          ),
          theItem.push(
            this.items[e].credit_redeem_count_sync === null
              ? "--"
              : this.items[e].credit_redeem_count_sync
          ),
          theItem.push(
            this.items[e].credit_count_sync === null
              ? "--"
              : this.items[e].credit_count_sync
          ),
          theItem.push(
            this.items[e].credit_gross_sync === null
              ? "--"
              : this.items[e].credit_gross_sync
          ),
          theItem.push(
            this.items[e].transfer_count_sync === null
              ? "--"
              : this.items[e].transfer_count_sync
          ),
          theItem.push(
            this.items[e].transfer_fee_card_sync === null
              ? "--"
              : this.items[e].transfer_fee_card_sync
          ),
          theItem.push(
            this.items[e].transfer_fee_cash_sync === null
              ? "--"
              : this.items[e].transfer_fee_cash_sync
          ),
          theItem.push(
            this.items[e].transfer_fee_gross_sync === null
              ? "--"
              : this.items[e].transfer_fee_gross_sync
          ),
          theItem.push(
            this.items[e].lost_transaction_count === null
              ? "--"
              : this.items[e].lost_transaction_count
          ),
          theItem.push(
            this.items[e].lost_transaction_total === null
              ? "--"
              : (this.items[e].lost_transaction_total).toFixed(2)
          ),
          theItem.push(
            this.items[e].gross_revenue_sync === null
              ? "--"
              : (+this.items[e].lost_transaction_total + this.items[e].gross_revenue_sync).toFixed(2)
          ),
          theItem.push(
            + this.items[e].lost_transaction_total +
            this.items[e].reload_count_sync +
              this.items[e].sold_count_sync +
              this.items[e].credit_sold_count_sync +
              this.items[e].credit_redeem_count_sync +
              this.items[e].transfer_count_sync +
              this.items[e].credit_count_sync
          ),
          theItem.push(
            this.items[e].discrepancy === null
              ? "--"
              : this.items[e].discrepancy
          ),
          theItem.push(
            this.items[e].cashier_name === null
              ? "--"
              : this.items[e].cashier_name
          );

        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    async syncToWireless(data) {
      this.messageDialog = true;
      this.messageTitle = "Wireless and Sync Shift";
      this.messageText =
        "Are you sure you want to align Wireless to Sync Shift?";
      this.action = "align";
      this.body = { shift_id: data.id };
    },
    closeMessageDialog() {
      this.messageDialog = false;
    },
    async saveAlignTransaction() {
      this.messageLoading = true;

      try {
        console.log(this.body);
        const response = await Services.shiftSyncToWireless(this.body);

        if (response.status === 201 || response.status === 204) {
          this.closeMessageDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Sync and Wireless has been aligned.",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      this.messageLoading = await false;
    },
    transactionALign(data) {
      this.messageDialogTransactionAlign = true;
      this.messageTitleTransactionAlign = "Transaction Align";
      this.messageTextTransactionAlign =
        "Are you sure you want to align Transaction?";
      this.actionTransactionAlign = "transactionAlign";
      this.bodyTransactionAlign = { shift_id: data.id };
    },
    closeTransactionALignMessageDialog() {
      this.messageDialogTransactionAlign = false;
    },
    async saveTransactionAlignTransaction() {
      this.messageLoadingTransactionALign = true;

      try {
        const response = await Services.transactionALign(
          this.bodyTransactionAlign
        );

        if (response.status === 201 || response.status === 204) {
          this.closeTransactionALignMessageDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Transaction has been aligned.",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      this.messageLoadingTransactionALign = await false;
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.clsScroll {
  width: auto;
  overflow-x: scroll;
  overflow-y: auto;
}

.tableOverall {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  height: 95%;
  border: 3px solid #000000;
}

.tableItemsTH {
  border: 1px solid #000000;
  text-align: center;
  /* padding: 4px; */
  font-size: 10px;
  font-weight: bold;
}

.tableItemsTD {
  border: 1px solid #000000;
  /* text-align: right; */
  padding: 4px;
  font-size: 10px;
  font-weight: bold;
}

.tableItemsTD2 {
  border: 1px solid #000000;
  /* text-align: right; */
  background-color: red;
  padding: 4px;
  font-size: 10px;
  font-weight: bold;
}

.tableTR:nth-child(even) {
  background-color: #f2f2f2;
}

.tableTR:hover {
  background-color: #ddd;
}
</style>
